export const cardStyles = {
  display: 'flex',
  border: '1px solid #C1C5CD',
  borderRadius: '12px',
  width: 'auto',
  boxShadow: 'none',
  height: '162px',
  '&:hover': {
    boxShadow: 'md',
    borderColor: 'neutral.outlinedHoverBorder'
  }
};
export const cardContent = {
  display: 'flex',
  flexDirection: 'column',
  height: '133px',
  gap: '18px'
};
export const cardTop = {
  height: '40px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignContent: 'flext-start'
};
export const cardTopLeft = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px'
};
export const titleContainer = {
  display: 'flex',
  alignItems: 'center',
  flexGrow: 'row',
  height: '20px',
  gap: '5px',
  alignContent: 'space-between'
};
export const titleStyles = {
  maxWidth: '160px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontSize: '18px',
  fontWeight: 600,
  letterSpacing: '0.25px',
  color: 'rgba(0, 0, 0, 1)'
};
export const dateContainer = {
  display: 'flex',
  alignItems: 'center',
  flexGrow: 'row',
  height: '16px',
  gap: '4px'
};
export const dateStyles = {
  lineHeight: '16px',
  fontSize: '11px',
  fontWeight: 500,
  letterSpacing: '0.5px',
  color: 'rgba(148, 151, 159, 1)'
};
export const cardTopRight = {
  display: 'flex',
  alignContent: 'flex-start'
};
export const statusContainer = {
  height: '32px',
  display: 'flex',
  flexGrow: 'row',
  borderRadius: '8px',
  border: '1px solid #E3E2E6',
  gap: '8px',
  alignItems: 'center',
  justifyContent: 'center'
};
export const statusStyles = {
  fontSize: '14px',
  fontWeight: 500,
  letterSpacing: '0.1px'
};
export const cardMiddle = {
  height: '30px',
  gap: '43px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between'
};
export const cardMiddleLeft = {
  display: 'flex',
  flexFlow: 'row',
  alignItems: 'center',
  gap: '8px'
};
export const overflowText = {
  lineHeight: '20px',
  fontSize: '12px',
  fontWeight: 500,
  letterSpacing: '0.25px',
  color: '#44474E'
};
export const cardMiddleRight = {
  height: '30px',
  display: 'flex',
  flexFlow: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '7px',
  padding: '12px',
  backgroundColor: '#F2F3FB',
  gap: '8px'
};
export const weeksLeftText = {
  fontSize: '12px',
  fontWeight: 500,
  letterSpacing: '0.4px',
  color: '#001E2F'
};

export const projectTypeText = {
  border: 1,
  borderRadius: '7px',
  borderColor: '#D7E2FF',
  padding: '5px 3px',
  width: '67px',
  height: '29px',
  fontSize: '12px',
  fontWeight: 400,
  textAlign: 'center',
  letterSpacing: '0.4px',
  color: '#001E2F'
};

export const cardBottom = {
  height: '30px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginBottom: '7px'
};

export const cardBottomLeft = {
  display: 'flex',
  flexFlow: 'row',
  alignItems: 'center',
  gap: '8px'
};
export const editBtn = {
  width: '78px',
  height: '27px',
  borderRadius: '33px',
  backgroundColor: '#E2ECF6',
  color: '#0054A5',
  textTransform: 'capitalize',
  fontSize: '14px',
  letterSpacing: '0.25px',
  fontWeight: 600,
  boxShadow: 'none',
  gap: '5px'
};
export const EditIcon: React.FC = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.546 5.49259L8.4855 4.43209L1.5 11.4176V12.4781H2.5605L9.546 5.49259ZM10.6065 4.43209L11.667 3.37159L10.6065 2.31109L9.546 3.37159L10.6065 4.43209ZM3.1815 13.9781H0V10.7958L5.03813 5.75772L10.0763 0.71959C10.2169 0.578987 10.4076 0.5 10.6065 0.5C10.8054 0.5 10.9961 0.578987 11.1368 0.71959L13.2585 2.84134C13.3991 2.98199 13.4781 3.17272 13.4781 3.37159C13.4781 3.57046 13.3991 3.76119 13.2585 3.90184L3.1815 13.9781Z"
      fill="#0054A5"
    />
  </svg>
);
